module.exports = __webpack_public_path__ + "static/media/circle-cropped.73a06b7c.png";